import { validateAndRefreshTokens } from "../Backend";
import { WebRoutes } from "../Constants";

import { ApiUrl } from "../Constants";

export async function apiCall(endpoint, requestOptions, filename) {
  const url = ApiUrl;

  // Add credentials option to requestOptions
  requestOptions.credentials = 'include';

  const response = await fetch(url + endpoint, requestOptions);

  switch (response.status) {
    case 500:
    case 200:
      let data;

      if (!filename) {
        try {
          data = await response.json();
          if (window.ACTIVATE_LOGS) {
            logApiCallResult(data, endpoint);
          }
        } catch (error) {
          if (window.ACTIVATE_LOGS) {
            console.log("No response to parse to JSON")
          }
        }
      } else {
        data = await response.blob().then((blob) => {
          const exportFile = document.createElement("a");
          document.body.appendChild(exportFile);
          const url = window.URL.createObjectURL(blob);
          exportFile.href = url;
          exportFile.download = filename;
          exportFile.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(exportFile);
          }, 0);
        });
      }
      return data;

    case 401:
      var isValid = await validateAndRefreshTokens();

      if (isValid) {
        requestOptions.headers.Authorization =
          "Bearer " + localStorage.getItem("accessToken");
        return await apiCall(endpoint, requestOptions);
      } else {
        sessionStorage.setItem("sesionExpired", true);
        window.location.href = WebRoutes.EntryPage;
      }
  }
}

const logApiCallResult = (res, endpoint) => {
  if (res.success) {
    console.log(endpoint + " Data:");
    console.log(res.data);
  } else {
    console.log(endpoint + " Errors:");
    console.log(res.errors);
  }
};

export async function apiCallJson(endpoint, method, body) {
  let requestOptions = {
    method: method,
    headers: {
      // Authorization: "Bearer " + localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    },
    body: method === "GET" ? undefined : JSON.stringify(body),
  };

  return await apiCall(endpoint, requestOptions);
}

export async function apiCallJsonWithFile(endpoint, method, body) {
  let formData = new FormData();

  for (const key in body) {
    if (body.hasOwnProperty(key)) {
      formData.set(key, body[key]);
    }
  }

  let requestOptions = {
    method: method,
    headers: {
      // Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
    "Content-Type": "multipart/form-data",
    body: method === "GET" ? undefined : formData,
  };

  return await apiCall(endpoint, requestOptions);
}

export async function apiCallExportFile(endpoint, method, body, filename) {
  let requestOptions = {
    method: method,
    headers: {
      // Authorization: "Bearer " + localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    },
    body: method === "GET" ? undefined : JSON.stringify(body),
  };

  return await apiCall(endpoint, requestOptions, filename);
}

export async function apiCallFile(endpoint, method, file) {
  var form = new FormData();
  form.set("file", file);
  let requestOptions = {
    method: method,
    headers: {
      // Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
    body: form,
  };

  return await apiCall(endpoint, requestOptions);
}
